module.exports = __webpack_public_path__ + "img/download-tile-bg-mobile_jp.7192b3d.jpg";